import { HTMLAttributes, Ref } from "react"

import { classNames } from "../../../lib/classNames"

export interface PopoverListItemProps extends HTMLAttributes<HTMLLIElement> {
  isHighlighted: boolean
  ref?: Ref<HTMLLIElement | null>
  disabled?: boolean
}

const PopoverListItem = (props: PopoverListItemProps) => {
  const {
    ref,
    className,
    isHighlighted,
    disabled = false,
    ...otherProps
  } = props

  return (
    <li
      className={classNames(
        "text-v2-foreground-default rounded-control text-body flex items-center",
        isHighlighted && !disabled && "bg-v2-background-surface-strong",
        !disabled && "active:bg-v2-background-surface-stronger",
        "min-h-8 gap-x-2 px-2",
        "cursor-pointer",
        disabled && "text-v2-foreground-default-disabled cursor-default",
        className
      )}
      {...otherProps}
      ref={ref}
    />
  )
}

PopoverListItem.displayName = "PopoverListItem"

export default PopoverListItem
